module.exports = __webpack_public_path__ + "static/media/head-side-medical.14fa4b65.svg";